// @flow

import React, { type ElementProps } from "react";
import { ArrayFieldTemplateProps } from "react-jsonschema-form";
import { Button, Col, Label, TooltipDropdown, Icon, Icons } from "@components";
import classNames from "classnames";

type Props = ElementProps<typeof ArrayFieldTemplateProps>;

const ArrayTemplate = (props: Props) => {
  const handleAdd = e => {
    e.preventDefault();
    props.onAddClick(e);
  };

  if (props.uiSchema["ui:widget"] === "hidden") {
    return null;
  }

  return (
    <div
      className={classNames("fc-schema-form-arr", {
        "form-group field-error": props.rawErrors && props.rawErrors.length,
      })}
    >
      <Col className="col-xs-12 px-0">
        <Label htmlFor={props.id} className="col-xs-12 fc-schema-form-arr__label">
          <span className="d-flex align-items-center">
            {props.title}
            {props.required || ((props.schema || {}).items || {}).required ? (
              <Icon icon="asterisk" size="xs" className="text-warning ml-2" />
            ) : null}
            {(props.uiSchema["ui:options"] || {}).tooltip ? (
              <TooltipDropdown {...props.uiSchema["ui:options"].tooltip} />
            ) : null}
          </span>
          {props.disabled ? null : (
            <Button className="link add-button ml-1" onClick={handleAdd} disabled={props.disabled}>
              <Icons.PlusIcon className={"mr-2"} />
              {(props.uiSchema["ui:options"] || {}).addButtonTitle}
            </Button>
          )}
        </Label>
        {props.rawErrors
          ? props.rawErrors.map(e => (
              <div key={e} className="text-danger mb-2">
                {e}
              </div>
            ))
          : null}
      </Col>
      {props.items.map(item => (
        <div key={item.index} className="fc-schema-form-arr__children">
          <div className="fc-schema-form-arr__children__content">{item.children}</div>
          {!props.disabled && (
            <Button
              className="secondary"
              onClick={item.onDropIndexClick(item.index)}
              disabled={props.disabled}
            >
              <Icons.CloseIcon
                className="default-icon-size"
                color={(props.uiSchema["ui:options"] || {}).closeIconeColor || "warning"}
              />
            </Button>
          )}
        </div>
      ))}
    </div>
  );
};

export default ArrayTemplate;
